// extracted by mini-css-extract-plugin
export default {"root":"style_root__L1GU+","mark":"style_mark__P+bNO","top":"style_top__gPSNv","bottom":"style_bottom__xBeYz","s":"style_s__O4mSE","c":"style_c__xM52G"};